/**
 * Eufy Smart Scale API サービス
 *
 * フルアクセス権限を持つユーザーのみ使用可能
 */

import { apiClient } from '@/api/client'
import type {
  BfProjectionResponse,
  EufyLoginRequest,
  EufyLoginResponse,
  EufyMeasurementsResponse,
  EufySnapshotResponse,
  EufyStatusResponse,
  EufySummaryResponse,
} from '@/api/types/eufy'

export const getEufyStatus = async (): Promise<EufyStatusResponse> => {
  const res = await apiClient.get('/eufy/status')
  return res.data
}

export const eufyLogin = async (body: EufyLoginRequest): Promise<EufyLoginResponse> => {
  const res = await apiClient.post('/eufy/login', body)
  return res.data
}

export const eufySelectCustomer = async (customerId: string): Promise<EufyStatusResponse> => {
  const res = await apiClient.post('/eufy/select-customer', { customer_id: customerId })
  return res.data
}

export const eufyLogout = async (): Promise<{ ok: boolean }> => {
  const res = await apiClient.post('/eufy/logout')
  return res.data
}

export const getEufyMeasurements = async (params: {
  customer_id?: string
  start?: string
  end?: string
  limit?: number
}): Promise<EufyMeasurementsResponse> => {
  const res = await apiClient.get('/eufy/measurements', { params })
  return res.data
}

export const getEufySummary = async (customerId?: string): Promise<EufySummaryResponse> => {
  const params = customerId ? { customer_id: customerId } : {}
  const res = await apiClient.get('/eufy/summary', { params })
  return res.data
}

export const getEufySnapshot = async (customerId?: string): Promise<EufySnapshotResponse | null> => {
  const params = customerId ? { customer_id: customerId } : {}
  const res = await apiClient.get('/eufy/snapshot', { params })
  return res.data
}

export const getBfProjection = async (days: number = 30): Promise<BfProjectionResponse> => {
  const res = await apiClient.get('/nutrition/bf-projection', { params: { days } })
  return res.data
}
